import { render, staticRenderFns } from "./orange-spot.vue?vue&type=template&id=58507c08&"
import script from "./orange-spot.vue?vue&type=script&lang=js&"
export * from "./orange-spot.vue?vue&type=script&lang=js&"
import style0 from "./orange-spot.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports